import React, { useEffect, useState } from 'react';
import { Navigate } from 'react-router-dom';
import { useAuth } from '../App';

// Live demo launcher: signs the visitor into the Demo Shelter sandbox account
// and drops them into the real application so ALL features are available.
const Demo = () => {
  const { login, user } = useAuth();
  const [status, setStatus] = useState('loading'); // loading | ready | error

  useEffect(() => {
    let active = true;
    const run = async () => {
      // If someone is already signed in, keep them but flag the demo session.
      if (user) {
        sessionStorage.setItem('scc_demo', '1');
        if (active) setStatus('ready');
        return;
      }
      const result = await login('admin', 'admin123');
      if (!active) return;
      if (result.success) {
        sessionStorage.setItem('scc_demo', '1');
        setStatus('ready');
      } else {
        setStatus('error');
      }
    };
    run();
    return () => { active = false; };
  }, [login, user]);

  if (status === 'ready') {
    return <Navigate to="/dashboard" replace />;
  }

  if (status === 'error') {
    return (
      <div className="min-h-screen bg-gray-50 flex items-center justify-center">
        <div className="text-center max-w-md mx-auto p-6">
          <div className="text-red-500 text-5xl mb-4">⚠️</div>
          <h2 className="text-xl font-semibold text-gray-700 mb-2">Demo Unavailable</h2>
          <p className="text-gray-500 mb-6">We couldn't start the demo right now. Please try again.</p>
          <div className="space-y-3">
            <button
              onClick={() => window.location.reload()}
              className="w-full bg-blue-600 hover:bg-blue-700 text-white px-4 py-2 rounded-lg font-medium"
            >
              Try Again
            </button>
            <a
              href="/signup"
              className="block w-full bg-green-500 hover:bg-green-600 text-white px-4 py-2 rounded-lg font-medium text-center"
            >
              Start Free Instead
            </a>
          </div>
        </div>
      </div>
    );
  }

  return (
    <div className="min-h-screen bg-gray-50 flex items-center justify-center">
      <div className="text-center">
        <div className="animate-spin rounded-full h-12 w-12 border-b-2 border-green-600 mx-auto mb-4"></div>
        <h2 className="text-xl font-semibold text-gray-700">Loading Demo…</h2>
        <p className="text-gray-500 mt-2">Setting up the full app with sample shelter data</p>
      </div>
    </div>
  );
};

export default Demo;
